import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';

// Public Pages
import Home from './pages/public/Home';
import CreatorProfiles from './pages/public/CreatorProfiles';
import Gallery from './pages/public/Gallery';
import Apply from './pages/public/Apply';
import Login from './pages/public/Login';
import Store from './pages/public/Store';
import OrderConfirmation from './pages/public/OrderConfirmation';
import NotFound from './pages/public/NotFound';

// Dashboard Pages
import DashboardLayout from './components/layout/DashboardLayout';
import ProtectedRoute from './components/common/ProtectedRoute';
import AdminPanel from './pages/dashboard/AdminPanel';

const ADMIN_HOST = 'admin.gamemeetsworld.com';
const isBrowser = typeof window !== 'undefined';
const hostname = isBrowser ? window.location.hostname : '';
const isLocalHost = !isBrowser || ['localhost', '127.0.0.1'].includes(hostname) || hostname.endsWith('.local');
const isAdminHost = hostname === ADMIN_HOST;

const adminBaseUrl = () => {
  if (!isBrowser) return `https://${ADMIN_HOST}`;
  const protocol = window.location.port ? 'http:' : 'https:';
  const port = window.location.port ? `:${window.location.port}` : '';
  return `${protocol}//${ADMIN_HOST}${port}`;
};

function ExternalRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return <div className="min-h-screen bg-[#021206] text-white grid place-items-center">Redirecting...</div>;
}

function PublicHostAdminRouteGuard({ children }) {
  const location = useLocation();
  if (isLocalHost || isAdminHost) return children;
  const next = `${location.pathname}${location.search}${location.hash}`;
  return <ExternalRedirect to={`${adminBaseUrl()}${next}`} />;
}

function AdminHostPublicRouteGuard({ children }) {
  if (isLocalHost || !isAdminHost) return children;
  return <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<AdminHostPublicRouteGuard><Home /></AdminHostPublicRouteGuard>} />
        <Route path="/creators" element={<AdminHostPublicRouteGuard><CreatorProfiles /></AdminHostPublicRouteGuard>} />
        <Route path="/gallery" element={<AdminHostPublicRouteGuard><Gallery /></AdminHostPublicRouteGuard>} />
        <Route path="/store" element={<AdminHostPublicRouteGuard><Store /></AdminHostPublicRouteGuard>} />
        <Route path="/order-confirmation" element={<AdminHostPublicRouteGuard><OrderConfirmation /></AdminHostPublicRouteGuard>} />
        <Route path="/apply" element={<AdminHostPublicRouteGuard><Apply /></AdminHostPublicRouteGuard>} />
        <Route path="/login" element={<PublicHostAdminRouteGuard><Login /></PublicHostAdminRouteGuard>} />

        {/* Protected Dashboard Routes */}
        <Route
          path="/dashboard"
          element={
            <PublicHostAdminRouteGuard>
              <ProtectedRoute requireAdmin>
                <DashboardLayout />
              </ProtectedRoute>
            </PublicHostAdminRouteGuard>
          }
        >
          <Route index element={<Navigate to="admin" replace />} />
          <Route path="admin" element={<AdminPanel />} />
        </Route>

        {/* 404 Catch-all */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}
